// jsaForm/v2/controlMeasures.actions.js

export const makeJsaV2ControlMeasuresActions = ({ setJsaUi, bump, emitJsaPatch }) => ({
  updateJsaV2Cm(jsaData, attribute, value, emitPatch) {
    jsaData.jsaControlMeasuresV2.updateAttribute(attribute, value);
    if (emitPatch) {
      const patch = jsaData.jsaControlMeasuresV2.toPatch({ [attribute]: value }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },

  showJsaV2CmSection(section, value) {
    setJsaUi({
      v2: (prev) => ({
        ...prev,
        controlMeasures: {
          ...(prev?.controlMeasures || {}),
          [section]: value,
        },
      }),
    });
    bump();
  },
});
